export function deleteLabel(applet, user) {
  return applet.author === user.login ? "Archive" : "Delete"
}

export function ctaCopyToConnect(userDevice, programmable, shortName) {
  const tapOrClick = userDevice === "desktop" ? "Click" : "Tap"

  return programmable
    ? `${tapOrClick} to connect ${shortName}`
    : `${tapOrClick} to connect`
}
